import React from "react";
import { Navigate, useLocation } from "react-router-dom";

const AuthProtected = ({ children }) => {
  const location = useLocation();

  // ✅ Unified Token
  const token = localStorage.getItem("token");

  // ✅ Logged User
  const user = JSON.parse(
    localStorage.getItem("user") || "{}"
  );

  // ✅ No token → login
  if (!token) {
    return <Navigate to="/login" replace />;
  }

  // ✅ Protect admin routes
  if (
    location.pathname.startsWith("/admin") &&
    user.role !== "Admin"
  ) {
    return <Navigate to="/dashboard" replace />;
  }

  return <>{children}</>;
};

export { AuthProtected };